module.exports = __webpack_public_path__ + "static/media/mcpayment_two.aa4843e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mcpayment_two.jpg
// module id = 103
// module chunks = 0